var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "all-info-container" }, [
    _c(
      "a",
      {
        attrs: { href: "javascript:void(0)" },
        on: {
          click: function($event) {
            _vm.print()
          }
        }
      },
      [
        _vm._v(
          "\n        " + _vm._s(_vm.$t("protegeAllInfo.printLink")) + "\n    "
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "printable" + _vm.protege.profile.id,
        staticClass: "all-info-container",
        attrs: { id: "printable" }
      },
      [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("guardian-title-component", {
                  attrs: {
                    title: _vm.fullname,
                    subtitle: _vm.$t("print.title")
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profile" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("profile.basicInformation.title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "firstname-form-group",
                              label: _vm.$t(
                                "profile.basicInformation.firstname"
                              ),
                              "label-for": "firstname-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "firstname-input",
                                name: "firstname-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.profile.firstname,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "firstname",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.firstname"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "lastname-form-group",
                              label: _vm.$t(
                                "profile.basicInformation.lastname"
                              ),
                              "label-for": "lastname-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "lastname-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.lastname,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "lastname", $$v)
                                },
                                expression: "protege.profile.lastname"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "address-form-group",
                              label: _vm.$t("profile.basicInformation.address"),
                              "label-for": "address-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "address-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.address,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "address", $$v)
                                },
                                expression: "protege.profile.address"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "address-extra-line-form-group",
                              label: _vm.$t(
                                "profile.basicInformation.addressExtraInformation"
                              ),
                              "label-for": "address-extra-line-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "address-extra-line-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.extraAddressLine,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "extraAddressLine",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.extraAddressLine"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "zipcode-form-group",
                              label: _vm.$t("profile.basicInformation.zipcode"),
                              "label-for": "zipcode-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "firstname-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.zipcode,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "zipcode", $$v)
                                },
                                expression: "protege.profile.zipcode"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "city-form-group",
                              label: _vm.$t("profile.basicInformation.city"),
                              "label-for": "city-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "city-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "city", $$v)
                                },
                                expression: "protege.profile.city"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("profile.contactInformation.title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "email-form-group",
                              label: _vm.$t("profile.contactInformation.email"),
                              "label-for": "email-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "email-input",
                                type: "text",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.profile.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "email", $$v)
                                },
                                expression: "protege.profile.email"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "mobile-form-group",
                              label: _vm.$t(
                                "profile.contactInformation.mobile"
                              ),
                              "label-for": "mobile-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "mobile-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.mobile,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "mobile", $$v)
                                },
                                expression: "protege.profile.mobile"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "phone-form-group",
                              label: _vm.$t("profile.contactInformation.phone"),
                              "label-for": "phone-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "phone-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "phone", $$v)
                                },
                                expression: "protege.profile.phone"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "website-form-group",
                              label: _vm.$t(
                                "profile.contactInformation.website"
                              ),
                              "label-for": "website-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "website-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.website,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "website", $$v)
                                },
                                expression: "protege.profile.website"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("profile.detailInformation.title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "profession-form-group",
                              label: _vm.$t(
                                "profile.detailInformation.profession"
                              ),
                              "label-for": "profession-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "profession-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.profession,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "profession",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.profession"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "employer-form-group",
                              label: _vm.$t(
                                "profile.detailInformation.employer"
                              ),
                              "label-for": "employer-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "employer-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.employer,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "employer", $$v)
                                },
                                expression: "protege.profile.employer"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ahv-number-form-group",
                              label: _vm.$t(
                                "profile.detailInformation.ahvNumber"
                              ),
                              "label-for": "ahv-number-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ahv-number-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.ahvNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "ahvNumber",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.ahvNumber"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "birthdate-form-group",
                              label: _vm.$t(
                                "profile.detailInformation.birthdate"
                              ),
                              "label-for": "birthdate-input"
                            }
                          },
                          [
                            _c("datepicker", {
                              staticClass: "o-form",
                              attrs: {
                                id: "birthdate-input",
                                format: "dd.MM.yyyy"
                              },
                              model: {
                                value: _vm.protege.profile.birthdate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "birthdate",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.birthdate"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "place-of-origin-form-group",
                              label: _vm.$t(
                                "profile.detailInformation.placeOfOrigin"
                              ),
                              "label-for": "place-of-origin-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "place-of-origin-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.placeOfOrigin,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "placeOfOrigin",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.placeOfOrigin"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "marital-status-form-group",
                              label: _vm.$t(
                                "profile.detailInformation.maritalStatus"
                              ),
                              "label-for": "marital-status-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "marital-status-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.maritalStatus,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "maritalStatus",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.maritalStatus"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "health-insurance-1-form-group",
                              label: _vm.$t(
                                "profile.detailInformation.healthInsurance1"
                              ),
                              "label-for": "health-insurance-1-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "health-insurance-1-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.healthInsurance1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "healthInsurance1",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.healthInsurance1"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "health-insurance-2-form-group",
                              label: _vm.$t(
                                "profile.detailInformation.healthInsurance2"
                              ),
                              "label-for": "health-insurance-2-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "health-insurance-2-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.healthInsurance2,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "healthInsurance2",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.healthInsurance2"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("profile.furtherInformation.title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "form-group",
                              label: _vm.$t(
                                "profile.furtherInformation.organDonor"
                              ),
                              "label-for": "organ-donor-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "organ-donor-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.organDonor,
                                callback: function($$v) {
                                  _vm.organDonor = $$v
                                },
                                expression: "organDonor"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "form-group",
                              label: _vm.$t(
                                "profile.furtherInformation.patientsProvision"
                              ),
                              "label-for": "firstname-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "firstname-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.patientsProvision,
                                callback: function($$v) {
                                  _vm.patientsProvision = $$v
                                },
                                expression: "patientsProvision"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "religion-form-group",
                              label: _vm.$t(
                                "profile.furtherInformation.religion"
                              ),
                              "label-for": "religion-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "religion-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.religion,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.profile, "religion", $$v)
                                },
                                expression: "protege.profile.religion"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "confession-form-group",
                              label: _vm.$t(
                                "profile.furtherInformation.confession"
                              ),
                              "label-for": "confession-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "confession-input",
                                type: "text",
                                placeholder: ""
                              },
                              model: {
                                value: _vm.protege.profile.confession,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.profile,
                                    "confession",
                                    $$v
                                  )
                                },
                                expression: "protege.profile.confession"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "burial" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("burial.meta") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.protege.burial.typeOfBurial !== "Andere Art"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "burial-form-group",
                                  label: _vm.$t("burial.typeOfBurial.title"),
                                  "label-for": "burial-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "burial-input",
                                    name: "burial-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.protege.burial.typeOfBurial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.burial,
                                        "typeOfBurial",
                                        $$v
                                      )
                                    },
                                    expression: "protege.burial.typeOfBurial"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.burial.typeOfGrave !== "Andere Art"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "grave-form-group",
                                  label: _vm.$t("burial.typeOfGrave.title"),
                                  "label-for": "grave-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "grave-input",
                                    name: "grave-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.protege.burial.typeOfGrave,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.burial,
                                        "typeOfGrave",
                                        $$v
                                      )
                                    },
                                    expression: "protege.burial.typeOfGrave"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.burial.typeOfBurial === "Andere Art"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "grave-form-group",
                                  label: _vm.$t("burial.typeOfBurial.title"),
                                  "label-for": "grave-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "grave-input",
                                    name: "grave-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.protege.burial.otherBurialText,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.burial,
                                        "otherBurialText",
                                        $$v
                                      )
                                    },
                                    expression: "protege.burial.otherBurialText"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.burial.typeOfGrave === "Andere Art"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "grave-form-group",
                                  label: _vm.$t("burial.typeOfGrave.title"),
                                  "label-for": "grave-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "grave-input",
                                    name: "grave-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.protege.burial.otherGraveText,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.burial,
                                        "otherGraveText",
                                        $$v
                                      )
                                    },
                                    expression: "protege.burial.otherGraveText"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ceremony" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("ceremony.location.ceremony-title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.protege.ceremony.locationTypeCeremony === "church"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "ceremony-restaurant-form-group",
                                  label: _vm.$t("ceremony.location.church"),
                                  "label-for": "ceremony-restaurant-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "ceremony-restaurant-input",
                                    name: "ceremony-restaurant-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.protege.ceremony.churchTextCeremony,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.ceremony,
                                        "churchTextCeremony",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "protege.ceremony.churchTextCeremony"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.ceremony.locationTypeCeremony === "nature"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "ceremony-club-form-group",
                                  label: _vm.$t("ceremony.location.nature"),
                                  "label-for": "ceremony-club-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "ceremony-club-input",
                                    name: "ceremony-club-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.protege.ceremony.natureTextCeremony,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.ceremony,
                                        "natureTextCeremony",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "protege.ceremony.natureTextCeremony"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.ceremony.locationTypeCeremony ===
                        "restaurantClub"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "ceremony-cabin-form-group",
                                  label: _vm.$t(
                                    "ceremony.location.restaurantClub"
                                  ),
                                  "label-for": "ceremony-cabin-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "ceremony-cabin-input",
                                    name: "ceremony-cabin-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.protege.ceremony
                                        .restaurantClubTextCeremony,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.ceremony,
                                        "restaurantClubTextCeremony",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "protege.ceremony.restaurantClubTextCeremony"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.ceremony.locationTypeCeremony ===
                        "otherLocation"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "ceremony-other-location-form-group",
                                  label: _vm.$t("ceremony.location.other"),
                                  "label-for": "ceremony-other-location-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "ceremony-other-location-input",
                                    name: "ceremony-other-location-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.protege.ceremony
                                        .locationOtherTextCeremony,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.ceremony,
                                        "locationOtherTextCeremony",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "protege.ceremony.locationOtherTextCeremony"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("ceremony.location.observance-title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _vm.protege.ceremony.locationTypeObservance === "church"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "ceremony-restaurant-form-group",
                                  label: _vm.$t("ceremony.location.church"),
                                  "label-for": "ceremony-restaurant-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "ceremony-restaurant-input",
                                    name: "ceremony-restaurant-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.protege.ceremony.churchTextObservance,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.ceremony,
                                        "churchTextObservance",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "protege.ceremony.churchTextObservance"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.ceremony.locationTypeObservance === "nature"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "ceremony-club-form-group",
                                  label: _vm.$t("ceremony.location.nature"),
                                  "label-for": "ceremony-club-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "ceremony-club-input",
                                    name: "ceremony-club-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.protege.ceremony.natureTextObservance,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.ceremony,
                                        "natureTextObservance",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "protege.ceremony.natureTextObservance"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.ceremony.locationTypeObservance ===
                        "restaurantClub"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "ceremony-cabin-form-group",
                                  label: _vm.$t(
                                    "ceremony.location.restaurantClub"
                                  ),
                                  "label-for": "ceremony-cabin-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "ceremony-cabin-input",
                                    name: "ceremony-cabin-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.protege.ceremony
                                        .restaurantClubTextObservance,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.ceremony,
                                        "restaurantClubTextObservance",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "protege.ceremony.restaurantClubTextObservance"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.protege.ceremony.locationTypeObservance ===
                        "otherLocation"
                          ? _c(
                              "b-form-group",
                              {
                                staticClass: "o-label",
                                attrs: {
                                  id: "ceremony-other-location-form-group",
                                  label: _vm.$t("ceremony.location.other"),
                                  "label-for": "ceremony-other-location-input"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "o-form",
                                  attrs: {
                                    id: "ceremony-other-location-input",
                                    name: "ceremony-other-location-input-name",
                                    type: "text",
                                    placeholder: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value:
                                      _vm.protege.ceremony
                                        .locationOtherTextObservance,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.protege.ceremony,
                                        "locationOtherTextObservance",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "protege.ceremony.locationOtherTextObservance"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("ceremony.decoration.title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ceremony-flower-form-group",
                              label: _vm.$t(
                                "ceremony.decoration.ceremonyFlowers"
                              ),
                              "label-for": "ceremony-flower-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ceremony-flower-input",
                                name: "ceremony-flower-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.ceremony.ceremonyFlowers,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.ceremony,
                                    "ceremonyFlowers",
                                    $$v
                                  )
                                },
                                expression: "protege.ceremony.ceremonyFlowers"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ceremony-observance-flower-form-group",
                              label: _vm.$t(
                                "ceremony.decoration.observanceFlowers"
                              ),
                              "label-for": "ceremony-observance-flower-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ceremony-observance-flower-input",
                                name: "ceremony-observance-flower-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.ceremony.observanceFlowers,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.ceremony,
                                    "observanceFlowers",
                                    $$v
                                  )
                                },
                                expression: "protege.ceremony.observanceFlowers"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ceremony-decoration-form-group",
                              label: _vm.$t(
                                "ceremony.decoration.observanceDecoration"
                              ),
                              "label-for": "ceremony-decoration-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ceremony-decoration-input",
                                name: "ceremony-decoration-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value:
                                  _vm.protege.ceremony.observanceDecoration,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.ceremony,
                                    "observanceDecoration",
                                    $$v
                                  )
                                },
                                expression:
                                  "protege.ceremony.observanceDecoration"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ceremony-decoration-misc-form-group",
                              label: _vm.$t(
                                "ceremony.decoration.decorationMisc"
                              ),
                              "label-for": "ceremony-decoration-misc-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ceremony-decoration-misc-input",
                                name: "ceremony-decoration-misc-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.ceremony.decorationMisc,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.ceremony,
                                    "decorationMisc",
                                    $$v
                                  )
                                },
                                expression: "protege.ceremony.decorationMisc"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("ceremony.food.title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ceremony-apero-form-group",
                              label: _vm.$t("ceremony.food.apero"),
                              "label-for": "ceremony-apero-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ceremony-apero-input",
                                name: "ceremony-apero-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.ceremony.apero,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.ceremony, "apero", $$v)
                                },
                                expression: "protege.ceremony.apero"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ceremony-menu-form-group",
                              label: _vm.$t("ceremony.food.menu"),
                              "label-for": "ceremony-menu-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ceremony-menu-input",
                                name: "ceremony-menu-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.ceremony.menu,
                                callback: function($$v) {
                                  _vm.$set(_vm.protege.ceremony, "menu", $$v)
                                },
                                expression: "protege.ceremony.menu"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ceremony-beverages-form-group",
                              label: _vm.$t("ceremony.food.beverages"),
                              "label-for": "ceremony-beverages-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ceremony-beverages-input",
                                name: "ceremony-decoration-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.ceremony.beverages,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.ceremony,
                                    "beverages",
                                    $$v
                                  )
                                },
                                expression: "protege.ceremony.beverages"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "ceremony-dishes-misc-form-group",
                              label: _vm.$t("ceremony.food.dishesMisc"),
                              "label-for": "ceremony-dishes-misc-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "ceremony-dishes-misc-input",
                                name: "ceremony-dishes-misc-input-name",
                                type: "text",
                                required: "",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.ceremony.dishesMisc,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.ceremony,
                                    "dishesMisc",
                                    $$v
                                  )
                                },
                                expression: "protege.ceremony.dishesMisc"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("ceremony.music.title") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("ceremony.music.ceremonyMusic")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.protege.musics.ceremonyMusics, function(
                          music
                        ) {
                          return _c("li", { key: music.id }, [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(music.musicText) +
                                "\n                                        "
                            )
                          ])
                        })
                      ),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("ceremony.music.ceremonyBand")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.protege.musics.ceremonyBands, function(
                          music
                        ) {
                          return _c("li", { key: music.id }, [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(music.musicText) +
                                "\n                                    "
                            )
                          ])
                        })
                      ),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("ceremony.music.observanceMusic")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.protege.musics.observanceMusics, function(
                          music
                        ) {
                          return _c("li", { key: music.id }, [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(music.musicText) +
                                "\n                                    "
                            )
                          ])
                        })
                      ),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("ceremony.music.observanceBand")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.protege.musics.observanceBands, function(
                          music
                        ) {
                          return _c("li", { key: music.id }, [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(music.musicText) +
                                "\n                                    "
                            )
                          ])
                        })
                      )
                    ])
                  ])
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "guestlist" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("guestlist.meta") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-table",
                          {
                            attrs: {
                              id: "contacts-table",
                              hover: "",
                              small: "",
                              fixed: "",
                              items: _vm.protege.guestlist,
                              "per-page": _vm.perPage,
                              "current-page": _vm.currentPage,
                              "total-rows": _vm.totalRows,
                              fields: _vm.computedFields
                            }
                          },
                          [
                            _c("template", {
                              staticClass: "o-thead",
                              slot: "HEAD_firstname"
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pets" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("pets.meta") }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-content" },
                  _vm._l(_vm.protege.pets, function(pet) {
                    return _c(
                      "div",
                      { key: pet.id },
                      [
                        _c("all-info-pet-component", {
                          attrs: {
                            name: pet.name,
                            species: pet.species,
                            transponderId: pet.transponderId,
                            birthdate: pet.birthdate,
                            veterinarian: pet.veterinarian,
                            custodyAfterDeath: pet.custodyAfterDeath,
                            notes: pet.notes
                          }
                        })
                      ],
                      1
                    )
                  })
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "documents" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("card-title-component", {
                  attrs: { title: _vm.$t("speeches.meta") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "funeral-oration-form-group",
                              label: _vm.$t("speeches.persons.burialSpeaker"),
                              "label-for": "funeral-oration-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "funeral-oration-input",
                                type: "text",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.speeches.burialSpeaker,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.speeches,
                                    "burialSpeaker",
                                    $$v
                                  )
                                },
                                expression: "protege.speeches.burialSpeaker"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "o-label",
                            attrs: {
                              id: "funeral-ceremony-speaker-form-group",
                              label: _vm.$t("speeches.persons.ceremonySpeaker"),
                              "label-for": "burial-speaker-input"
                            }
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "o-form",
                              attrs: {
                                id: "burial-speaker-input",
                                type: "text",
                                placeholder: "",
                                disabled: ""
                              },
                              model: {
                                value: _vm.protege.speeches.ceremonySpeaker,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.protege.speeches,
                                    "ceremonySpeaker",
                                    $$v
                                  )
                                },
                                expression: "protege.speeches.ceremonySpeaker"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8374aac8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8374aac8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/ProtegeAllInfoComponent.vue
// module id = null
// module chunks = 